/*
 * @Author: huangying
 * @Date: 2021-12-30 13:53:27
 * @Last Modified by: huxianyong
 * @Last Modified time: 2023-06-06 10:05:38
 */
import config from '../config.json'
export default function user_page() {
  return `
    <div class="content flex_column flex_c">
      <p swiper-animate-effect="fadeInUp" class="ani title fs-40 mt-20">
        他们正在使用睿美云
      </p>
      <p
        swiper-animate-effect="fadeInUp"
        swiper-animate-delay="0.1s"
        class="ani sub_title fs-24"
      >
        ${config.total}家医疗美容机构的信任
      </p>
      <button
        swiper-animate-effect="fadeInUp"
        swiper-animate-delay="0.2s"
        class="ani flex_n button button_small apply_btn"
      >
        申请试用
      </button>
      <div class="user_main mb-60">
        ${config.imgList
          .map((column) => {
            return `
            <div class="user_animation${column.length}">
              ${[...column, ...column]
                .map((item) => {
                  const img = require(`../../assets/user/brand/${item}`)
                  return `
                  <img
                    oncontextmenu="return false;"
                    src="${img}"
                    alt=""
                    srcset=""
                  />
                `
                })
                .join('')}
            </div>
          `
          })
          .join('')}
      </div>
    </div>
  `
}
